/**
 * NIMUS CLOUD API Backend
 * NIMUS Cloud Backend Documentation
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { PlantItemSearchDto } from '../model/plantItemSearchDto';
import { PlantSaveRequestDto } from '../model/plantSaveRequestDto';
import { PlantSearchRequestDto } from '../model/plantSearchRequestDto';
import { PlantSearchResponseDto } from '../model/plantSearchResponseDto';
import { PlantUpdateRequestDto } from '../model/plantUpdateRequestDto';
import { SuccessDto } from '../model/successDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class PlantProfilesService {
  protected basePath = 'http://127.0.0.1:3000/api';

  public defaultHeaders = new HttpHeaders();

  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Plants profiles global item delete
   *
   * @param profile_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerDeleteGlobal(
    profile_id: number,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<SuccessDto>;
  public plantsControllerDeleteGlobal(
    profile_id: number,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<SuccessDto>>;
  public plantsControllerDeleteGlobal(
    profile_id: number,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<SuccessDto>>;
  public plantsControllerDeleteGlobal(
    profile_id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (profile_id === null || profile_id === undefined) {
      throw new Error(
        'Required parameter profile_id was null or undefined when calling plantsControllerDeleteGlobal.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<SuccessDto>(
      'delete',
      `${this.basePath}/plants/global/${encodeURIComponent(String(profile_id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Plants profiles global item delete
   *
   * @param profile_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerDeleteUser(
    profile_id: number,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<SuccessDto>;
  public plantsControllerDeleteUser(
    profile_id: number,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<SuccessDto>>;
  public plantsControllerDeleteUser(
    profile_id: number,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<SuccessDto>>;
  public plantsControllerDeleteUser(
    profile_id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (profile_id === null || profile_id === undefined) {
      throw new Error(
        'Required parameter profile_id was null or undefined when calling plantsControllerDeleteUser.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<SuccessDto>(
      'delete',
      `${this.basePath}/plants/user/${encodeURIComponent(String(profile_id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Plants profiles global item get
   *
   * @param profile_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerGetGlobal(
    profile_id: number,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<PlantItemSearchDto>;
  public plantsControllerGetGlobal(
    profile_id: number,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<PlantItemSearchDto>>;
  public plantsControllerGetGlobal(
    profile_id: number,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<PlantItemSearchDto>>;
  public plantsControllerGetGlobal(
    profile_id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (profile_id === null || profile_id === undefined) {
      throw new Error(
        'Required parameter profile_id was null or undefined when calling plantsControllerGetGlobal.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<PlantItemSearchDto>(
      'get',
      `${this.basePath}/plants/global/${encodeURIComponent(String(profile_id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Plants profiles user item get
   *
   * @param profile_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerGetUser(
    profile_id: number,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<PlantItemSearchDto>;
  public plantsControllerGetUser(
    profile_id: number,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<PlantItemSearchDto>>;
  public plantsControllerGetUser(
    profile_id: number,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<PlantItemSearchDto>>;
  public plantsControllerGetUser(
    profile_id: number,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (profile_id === null || profile_id === undefined) {
      throw new Error(
        'Required parameter profile_id was null or undefined when calling plantsControllerGetUser.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<PlantItemSearchDto>(
      'get',
      `${this.basePath}/plants/user/${encodeURIComponent(String(profile_id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Add global plant profile
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerSaveGlobal(
    body: PlantSaveRequestDto,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<SuccessDto>;
  public plantsControllerSaveGlobal(
    body: PlantSaveRequestDto,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<SuccessDto>>;
  public plantsControllerSaveGlobal(
    body: PlantSaveRequestDto,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<SuccessDto>>;
  public plantsControllerSaveGlobal(
    body: PlantSaveRequestDto,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling plantsControllerSaveGlobal.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<SuccessDto>('post', `${this.basePath}/plants/global`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Add user plant profile
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerSaveUser(
    body: PlantSaveRequestDto,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<SuccessDto>;
  public plantsControllerSaveUser(
    body: PlantSaveRequestDto,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<SuccessDto>>;
  public plantsControllerSaveUser(
    body: PlantSaveRequestDto,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<SuccessDto>>;
  public plantsControllerSaveUser(
    body: PlantSaveRequestDto,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling plantsControllerSaveUser.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<SuccessDto>('post', `${this.basePath}/plants/user`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Plants profiles search
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerSearchGlobal(
    body: PlantSearchRequestDto,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<PlantSearchResponseDto>;
  public plantsControllerSearchGlobal(
    body: PlantSearchRequestDto,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<PlantSearchResponseDto>>;
  public plantsControllerSearchGlobal(
    body: PlantSearchRequestDto,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<PlantSearchResponseDto>>;
  public plantsControllerSearchGlobal(
    body: PlantSearchRequestDto,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling plantsControllerSearchGlobal.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<PlantSearchResponseDto>(
      'post',
      `${this.basePath}/plants/search`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Update exist plant profile
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerUpdateGlobal(
    body: PlantUpdateRequestDto,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<SuccessDto>;
  public plantsControllerUpdateGlobal(
    body: PlantUpdateRequestDto,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<SuccessDto>>;
  public plantsControllerUpdateGlobal(
    body: PlantUpdateRequestDto,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<SuccessDto>>;
  public plantsControllerUpdateGlobal(
    body: PlantUpdateRequestDto,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling plantsControllerUpdateGlobal.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<SuccessDto>('put', `${this.basePath}/plants/global`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Update exist plant profile
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public plantsControllerUpdateUser(
    body: PlantUpdateRequestDto,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<SuccessDto>;
  public plantsControllerUpdateUser(
    body: PlantUpdateRequestDto,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<SuccessDto>>;
  public plantsControllerUpdateUser(
    body: PlantUpdateRequestDto,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<SuccessDto>>;
  public plantsControllerUpdateUser(
    body: PlantUpdateRequestDto,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling plantsControllerUpdateUser.',
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<SuccessDto>('put', `${this.basePath}/plants/user`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
